import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';

@Injectable({
  providedIn: 'root'
})
export class HubSession implements Session
{
    constructor() { }

    get(): string | SessionCode
    {
        try{
            const hub = localStorage.getItem( SessionKey.HUB ) 

            if (!hub) return SessionCode.MISSING_VALUE

            return hub         
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set(hub: string): SessionCode
    {
        if(!hub) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.HUB, hub ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.ORGANIZATION ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

